<zaeper-dashboard-layout
  [dashboardLayout]="dashboardLayout"
  [navItems]="navItems"
  [branding]="branding"
>
  <ng-template zTemplate="topBarLeft">
    <div class="relative flex flex-row items-center h-full gap-x-2">
      <app-cloud-quick-access-menu />
      <app-group-quick-access-menu />
      <app-receiver-quick-access-menu/>
    </div>
  </ng-template>

  <ng-template zTemplate="topBarRight">
    <div class="flex items-center gap-2">
      <app-user-menu />
      <p-button
        (onClick)="openAppSwitcher()"
        icon="pi pi-th-large"
        [text]="true"
        [rounded]="true"
        severity="secondary"
      ></p-button>
    </div>
  </ng-template>

  <ng-template zTemplate="body">
    <ng-content></ng-content>
  </ng-template>
</zaeper-dashboard-layout>
